// components/ProductList.tsx
import React from "react";
import { FormattedMessage } from "react-intl";
import { Empty } from "components";
import { IThirdPartyService, INTEGRATED_SERVICE } from "request";
import { ProductRow } from "./ProductRow";
import { Skeleton } from "antd-mobile";

interface ProductListProps {
  connectService: IThirdPartyService | undefined;
  productList: any[];
  isLoading: boolean;
}

export const ProductList: React.FC<ProductListProps> = ({
  connectService,
  productList,
  isLoading,
}) => {
  const SkeletonItem = () => {
    const logoStyle = {
      "--width": "54px",
      "--height": "54px",
      "--border-radius": "8px",
    };

    const titleStyle = {
      "--width": "50%",
      "--border-radius": "2px",
    };

    return (
      <div className="bg-white dark:bg-gray323434 rounded px-4 py-4 flex flex-row items-center mt-3">
        <div>
          <Skeleton animated style={logoStyle} />
        </div>
        <div className="w-full flex flex-col gap-4 px-3 flex-1">
          <div className="flex flex-col gap-1">
            <Skeleton
              animated
              style={{ ...titleStyle, "--height": "24px", "--width": "30%" }}
            />
            <Skeleton animated style={{ ...titleStyle, "--height": "16px" }} />
          </div>
          <div className="flex flex-col gap-1">
            <Skeleton
              animated
              style={{ ...titleStyle, "--height": "18px", "--width": "70%" }}
            />
          </div>
        </div>
      </div>
    );
  };

  const renderProductTitle = () => {
    if (connectService?.showFlag === INTEGRATED_SERVICE.googleAssistant) {
      return <FormattedMessage id="thirdParty.connect.product.title" />;
    }

    if (
      connectService?.showFlag === INTEGRATED_SERVICE.appleHealth ||
      connectService?.showFlag === INTEGRATED_SERVICE.googleFit ||
      connectService?.showFlag === INTEGRATED_SERVICE.healthConnect
    ) {
      return (
        <FormattedMessage id="thirdParty.connect.product.supportedProducts" />
      );
    }

    return null;
  };

  return (
    <>
      <p className="mt-6">{renderProductTitle()}</p>
      {isLoading ? (
        <>
          <SkeletonItem />
          <SkeletonItem />
        </>
      ) : (
        <>
          {(!productList || productList.length === 0) && (
            <Empty
              emptyText={<FormattedMessage id="thirdParty.data.empty.text" />}
            />
          )}
          <div className="overflow-y-auto pb-[88px]">
            {productList &&
              productList.length > 0 &&
              productList.map((product, key) => (
                <ProductRow
                  product={product}
                  key={key}
                  isVoiceProduct={
                    connectService?.showFlag ===
                    INTEGRATED_SERVICE.googleAssistant
                  }
                />
              ))}
          </div>
        </>
      )}
    </>
  );
};
